import script from "./AuthPage.vue?vue&type=script&setup=true&async=true&lang=js"
export * from "./AuthPage.vue?vue&type=script&setup=true&async=true&lang=js"

import "./AuthPage.vue?vue&type=style&index=0&id=77ee778e&lang=css"

const __exports__ = script;

export default __exports__